export default "__VITE_ASSET__BRyZrVPT__"